import { render, staticRenderFns } from "./rsg-tools.vue?vue&type=template&id=c8004684&scoped=true"
import script from "./rsg-tools.vue?vue&type=script&lang=js"
export * from "./rsg-tools.vue?vue&type=script&lang=js"
import style0 from "./rsg-tools.vue?vue&type=style&index=0&id=c8004684&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8004684",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8004684')) {
      api.createRecord('c8004684', component.options)
    } else {
      api.reload('c8004684', component.options)
    }
    module.hot.accept("./rsg-tools.vue?vue&type=template&id=c8004684&scoped=true", function () {
      api.rerender('c8004684', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/account/views/rsg-tools.vue"
export default component.exports